import React from 'react';
import { infoToolTip } from '../../../../../assets/hostedassets';

// Solid "Mismatch" pill per design: #B25255, 16px radius, 5px/8px padding,
// Gilroy Medium 12px, white text + white info icon.
const MismatchPill = () => (
    <div
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            padding: '5px 8px',
            height: '24px',
            borderRadius: '16px',
            background: '#B25255',
            color: '#FFFFFF',
            fontFamily: 'var(--text-gilroy-medium)',
            fontSize: '12px',
            lineHeight: '100%',
            letterSpacing: 0,
            textAlign: 'center',
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
        }}
    >
        <span>Mismatch</span>
        {/* black info svg rendered white on the dark pill via filter (same trick as .CircularDarkRed) */}
        <img
            src={infoToolTip}
            alt="Balance mismatch"
            style={{ width: '14px', height: '14px', filter: 'brightness(0) invert(1)' }}
        />
    </div>
);

export default MismatchPill;
